import React, {Fragment, useContext, useEffect, useState} from 'react';
import AuthContext from '../../../../context/autentication/authContext';
import DescargasContext from '../../../../context/descargas/descargasContext';

import BaseUniversoTabla from './BaseUniversoTabla';
import Spinner from '../../spinner/Spinner';
import * as XLSX from 'xlsx'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFileDownload
  } from '@fortawesome/free-solid-svg-icons';

const BaseUniverso = () => {
    const authContext = useContext(AuthContext);
    const { usuario } = authContext;


    const descargasContext = useContext(DescargasContext);
    const { fnDescargasBaseUniversoProspectosSectorCliente, baseUniversoProspectosSectorCliente, nombreBaseUniversoProspectosSectorCliente, loadingSpinner } = descargasContext;

    const [carga, setCarga] = useState(false);
      
    useEffect( () => {
        if(carga === true || !usuario ) return;
        if(usuario){
            //console.log(usuario.id_usu_cliente);
            const datos = {
                usuario: usuario.desc_usu_email,
                idCliente: usuario.id_usu_cliente
              }
            fnDescargasBaseUniversoProspectosSectorCliente(datos); 

        }

        setCarga(true);
        // eslint-disable-next-line
    }, [usuario]);
    
    const OnClickDownloadBaseUniverso = () =>{
        let sheetDown = [];
        let extension = '';

        sheetDown = baseUniversoProspectosSectorCliente;
        extension = 'xlsx';
        
        var wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(sheetDown);
        XLSX.utils.book_append_sheet(wb, ws, 'MiHoja1');
        XLSX.writeFile(wb, `${nombreBaseUniversoProspectosSectorCliente}.${extension}`);
        
    }

    return (
        <Fragment>
            {(loadingSpinner) ? <div className='spinner mt-5 pt-5'><Spinner/></div>
            :
            <div className='container'>
                <div className='card border-info mb-3'>
                    <div className='card-header resultados-header'>
                            <h4 className='table-title'>Base de Prospección</h4>
                            <div className='text-start'>
                                <button
                                    className='btnCorto btn-azulEPCont mr-2'
                                    onClick={() => window.open('https://forms.gle/gaUVa2kjUGBVXS667', '_blank')}
                                >
                                    <FontAwesomeIcon
                                    className='btn-table-title-icon'
                                    //icon={faExternalLinkAlt} size='lg'
                                    />
                                    Cambiar Parámetros
                                </button>
                                <button
                                    className='btnCorto btn-primario'
                                    data-toggle='tooltip' data-placement='top' title='Descargar Excel'
                                    onClick={() => OnClickDownloadBaseUniverso()}
                                //disabled={btnDisableNuevoMsg}
                                >
                                    <FontAwesomeIcon
                                        className='btn-table-title-icon mr-2'
                                        icon={faFileDownload} size='lg'
                                    />Descargar Base
                                </button>
                            </div>
                            
                    </div>
                    <div className='card-body'>
                        <p>Una vez modificados tus parámetros, la nueva BBDD de prospección se genera en 24 horas</p>
                        <BaseUniversoTabla 
                            nombreBaseUniversoProspectosSectorCliente={nombreBaseUniversoProspectosSectorCliente}
                            baseUniversoProspectosSectorCliente={baseUniversoProspectosSectorCliente}
                        />
                    </div>
                </div>
            </div>
            }
        </Fragment>
    )
}

export default BaseUniverso;